import { useClients } from '@entities/clients';
import { useClientIdsSelect } from '@entities/clients/heplers.ts';
import { useGroups } from '@entities/common/groups';
import cn from 'classnames';
import type React from 'react';
import { useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { Header } from '@widgets/header';
import { useTempClientFormPageRedirect } from '@features/clients/client-form/ui/form/helpers.ts';
import { ClientInfoWithList } from '@features/clients/client-info-with-list/index.tsx';
import { ToolbarDynamicButtons } from '@features/clients/client-toolbar-dynamic-buttons';
import { Search, useFilter, useLoadTags } from '@features/common';
import { Add, ArrowShortLeft, FilterIcon, Mark, Search as SearchIcon, SortIcon } from '@shared/assets';
import { useWindowWidth } from '@shared/hooks';
import { IconButton, PageHead, PageTitle } from '@shared/ui';
import * as st from './styles.module.scss';

export const ClientsPage: React.FC = () => {
  const { nameClients } = useClients();
  const { isMobile, isMobileWithSelecting, isSelecting, toggleSelectionMode } =
    useClientIdsSelect();

  const { search, onSearch, searchNotes, onSearchNotes } = useFilter();
  const { code = '' } = useParams<{ code: string }>();

  const { resetSelectedGroups } = useGroups();
  const { redirectOnClientForm } = useTempClientFormPageRedirect();
  const { groupId } = useParams();

  const listParams = { search: search };

  const windowWidth = useWindowWidth();

  useLoadTags(code);

  const [isSearchMobile, setIsSearchMobile] = useState(false);
  return (
    <>
      {!isSearchMobile && (
        <>
          <Header MCenter={<> Клиенты</>} />
          {isSelecting && windowWidth <= 768 && <PageTitle title={'Клиенты / Выбор'} />}
          <PageHead
            Left={
              groupId || (isMobile && isSelecting) ? (
                <section>
                  <IconButton variant="dark" onClick={toggleSelectionMode}>
                    <ArrowShortLeft />
                  </IconButton>
                </section>
              ) : (
                <section className={st.nav}>
                  <NavLink
                    to={`/clients/clients`}
                    className={({ isActive }) => cn(st.tab, isActive && st.active)}
                  >
                    Все
                  </NavLink>
                  <NavLink
                    to={`/clients/groups`}
                    className={({ isActive }) => cn(st.tab, isActive && st.active)}
                  >
                    Группы
                  </NavLink>
                </section>
              )
            }
            LeftSecondLine={
              isMobileWithSelecting ? <ToolbarDynamicButtons withCount={false} /> : null
            }
            Right={
              <>
                {!isMobile ? (
                  <Search
                    search={search}
                    onSearch={onSearch}
                    titles={nameClients}
                    additionalChildren={<ToolbarDynamicButtons />}
                  />
                ) : (
                  <>
                    <ToolbarDynamicButtons withButtons={!isMobile} />
                    <IconButton variant="mobile" onClick={() => setIsSearchMobile(!isSearchMobile)}>
                      <SearchIcon />
                    </IconButton>
                  </>
                )}
                <Tooltip title="Сортировка">
                  <div>
                    <IconButton variant="dark">
                      <SortIcon />
                    </IconButton>
                  </div>
                </Tooltip>
                <Tooltip title="Фильтр">
                  <div>
                    <IconButton variant="dark">
                      <FilterIcon />
                    </IconButton>
                  </div>
                </Tooltip>
                <Tooltip title="Выбрать">
                  <div>
                    <IconButton
                      className={cn(isSelecting && st.checkbox)}
                      variant={isSelecting ? 'active' : 'dark'}
                      onClick={() => toggleSelectionMode()}
                    >
                      <Mark />
                    </IconButton>
                  </div>
                </Tooltip>

                <Tooltip title="Добаить">
                  <div>
                    <IconButton
                      variant="dark"
                      onClick={() => {
                        redirectOnClientForm(`/clients/clients/edit/new`);
                        resetSelectedGroups();
                      }}
                    >
                      <Add />
                    </IconButton>
                  </div>
                </Tooltip>
              </>
            }
          />
        </>
      )}
      {isSearchMobile && (
        <>
          <PageTitle title="Поиск" />
          <PageHead
            Left={
              <IconButton
                variant="dark"
                onClick={() => {
                  setIsSearchMobile(!isSearchMobile);
                  onSearch('');
                }}
              >
                <ArrowShortLeft />
              </IconButton>
            }
            Right={<Search mobile search={search} onSearch={onSearch} titles={nameClients} />}
          />
        </>
      )}
      <ClientInfoWithList
        isHeaderWithToLines={isMobileWithSelecting}
        listParams={listParams}
        searchNotes={searchNotes}
        onSearchNotes={onSearchNotes}
      />
    </>
  );
};
